import { Component, OnInit } from '@angular/core';
import { PreAuthenticationResponse } from '@picard/models-lib';
import { Title } from '@angular/platform-browser';
import { StorageConstants } from '@picard/shared-lib';
import { ApplicationService } from '@picard/services-lib';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  docTheme = document.getElementById('theme-css');
  docLayout = document.getElementById('layout-css');
  //#endregion Properties

  //#region Constructor
  constructor(private _title: Title, private _applicationService: ApplicationService) {
    if (this.docTheme) {
      this.docTheme.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.theme);
    }
    if (this.docLayout) {
      this.docLayout.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.layout);
    }}
  //#endregion Constructor

  //#region Functions
  ngOnInit() {
    const preAuthJson = sessionStorage.getItem(StorageConstants.preAuth);
    if (preAuthJson) {
      this.preAuthenticationResponse = JSON.parse(preAuthJson);
      this._title.setTitle(`${this.preAuthenticationResponse.description} - Authorization Failed`);
    } else {
      this._title.setTitle('ElectronicLine');
    }
  }
  //#endregion Functions
}
